import React, { forwardRef, type ReactNode } from 'react';

import { Box, type BoxProps } from '@atlaskit/primitives';

export interface TableProps extends BoxProps<'table'> {
	/**
	 * A `testId` prop is a unique string that appears as a data attribute `data-testid`
	 * in the rendered code, serving as a hook for automated tests.
	 */
	testId?: string;

	/**
	 * Table content.
	 */
	children: ReactNode;
}

/**
 * __Table__
 *
 * A primitive table container. Applies the HTML native element with no other styling.
 *
 * - [Examples](https://atlassian.design/components/table/examples)
 *
 * @primitive
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/1947062524/Dynamic+table+2.0+implementation+spec
 */
export const Table = forwardRef<HTMLTableElement, TableProps>(
	({ children, testId, ...props }, ref) => {
		return (
			<Box as="table" testId={testId} ref={ref} {...props}>
				{children}
			</Box>
		);
	},
);
